/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Back_To_Login_ButtonInputs */



/**
* | output |
* | --- |
* | "Back to Login" |
*
* @param {Login_Back_To_Login_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_back_to_login_button = /** @type {((inputs?: Login_Back_To_Login_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Back_To_Login_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Retour à la Connexion")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zurück zur Anmeldung")
	if (locale === "it") return /** @type {LocalizedString} */ ("Torna al login")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Вернуться к входу")
	if (locale === "es") return /** @type {LocalizedString} */ ("Volver al inicio de sesión")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("返回登录")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ログインに戻る")
	if (locale === "hi") return /** @type {LocalizedString} */ ("लॉगिन पर वापस जाएं")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Voltar ao login")
	return /** @type {LocalizedString} */ ("Back to Login")
});